module.exports = __webpack_public_path__ + "582ec4caf3f4ca34e73176f2c6e0bf40.svg";